// frontend/src/pages/PasswordResetRequestPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../services/api';
import LoadingSpinner from '../components/Common/LoadingSpinner';

const PasswordResetRequestPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');
    try {
      // dj_rest_auth's password reset endpoint expects a POST request with the email
      await apiClient.post('auth/password/reset/', { email });
      setMessage('If an account with this email exists, a password reset link has been sent. Please check your inbox (and spam folder).');
    } catch (err) {
      // It's good practice not to reveal if an email exists or not for security reasons.
      // So, even on error, a generic success message is often preferred.
      // However, if the API returns specific errors you want to show (like rate limiting), handle them.
      // For now, we'll show a generic success message to prevent email enumeration.
      setMessage('If an account with this email exists, a password reset link has been sent. Please check your inbox (and spam folder).');
      // setError(err.response?.data?.detail || 'Failed to send password reset email. Please try again.');
      console.error("Password reset request error:", err.response?.data || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-var(--navbar-height,88px)-var(--footer-height,88px))] flex flex-col items-center justify-center bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">Reset Your Password</h2>
          <p className="mt-2 text-sm text-gray-600">
            Enter your email address and we will send you instructions to reset your password.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 sm:p-10 shadow-xl rounded-lg border border-gray-200">
          {isLoading && <div className="text-center mb-4"><LoadingSpinner /></div>}
          {message && <p className="text-green-600 text-sm text-center bg-green-100 p-3 rounded-md mb-4">{message}</p>}
          {error && <p className="text-red-600 text-sm text-center bg-red-100 p-3 rounded-md mb-4">{error}</p>}
          
          {!message && ( // Hide form after successful message to prevent resubmission
            <>
              <div>
                <label htmlFor="email-request-reset" className="block text-sm font-medium leading-6 text-gray-900">
                  Email address
                </label>
                <div className="mt-2">
                  <input
                    id="email-request-reset"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="block w-full rounded-md border-0 py-2.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                    placeholder="you@example.com"
                  />
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full flex justify-center py-2.5 px-5 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white transition-colors duration-150 ease-in-out ${
                    isLoading
                      ? 'bg-blue-400 cursor-not-allowed'
                      : 'bg-blue-600 hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600'
                  }`}
                >
                  {isLoading ? 'Sending...' : 'Send Password Reset Email'}
                </button>
              </div>
            </>
          )}
        </form>
        <p className="mt-8 text-center text-sm text-gray-500">
          Remember your password?{' '}
          <Link to="/login" className="font-semibold leading-6 text-blue-600 hover:text-blue-500">
            Login here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PasswordResetRequestPage;

